type SortableListByCreateAt = {
  created_at: string
}

type SortableListByUpdateAt = {
  updated_at: string
}

export const sortByCreateAt = <T extends SortableListByCreateAt>(list: T[]) =>
  list.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())

export const isNullOrUndefined = (value: unknown) => value === null || value === undefined

export const isNullOrUndefinedOrEmpty = (value: unknown) => isNullOrUndefined(value) || value === ``

export const isNullOrUndefinedOrEmptyObject = (value: unknown) => {
  if (isNullOrUndefined(value)) return true
  if (typeof value !== `object`) return false
  const isArray = Array.isArray(value)
  if (isArray) return value.length === 0
  const isDate = value instanceof Date
  if (isDate) return false
  // const isBigInt = typeof value === `bigint`
  // if (isBigInt) return false
  return Object.keys(value!).length === 0
}

export const sortByUpdateAt = <T extends SortableListByUpdateAt>(list: T[]) =>
  list.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime())

export const removeUndefinedValues = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined && !Number.isNaN(value)) {
      acc[key as keyof T] = value
    }
    return acc
  }, {} as Partial<T>)

export const isNumberEqual = (a: unknown, b: unknown) => {
  if (a === null || (b === null && a !== b)) return false
  const numberA = Number(a)
  const numberB = Number(b)
  if (Number.isNaN(numberA) || Number.isNaN(numberB)) return false
  return numberA === numberB
}
